import React, { useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { simulateIntervalDataDev } from '/imports/api/devtools';
import { toastOnError } from '/imports/ui/utils';
import { DevToolSection } from '/imports/ui/DevToolSection';
import { Input } from '/imports/ui/Input';
import { Button } from '/imports/ui/Button';

const Controls = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
`;

/** Dev tool panel that simulates a project's interval load profile and shows summary stats. */
export const DevToolIntervalData = () => {
  const [projectId, setProjectId] = useState('');
  const [annualConsumption, setAnnualConsumption] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');
  const run = toastOnError(async () => {
    if (!projectId.trim()) return toast.error('Enter a project _id first.');
    setLoading(true);
    setResult('');
    try {
      const ac = annualConsumption.trim() ? Number(annualConsumption.trim()) : undefined;
      const res = await simulateIntervalDataDev.call({ projectId: projectId.trim(), annualConsumption: ac });
      setResult(JSON.stringify(res, null, 2));
    }
    finally {
      setLoading(false);
    }
  });
  return (
    <DevToolSection
      title="Interval Data (Load Profile)"
      description="Simulate a project's 12-month 15-min load profile (the ETB input) and show summary stats. Leave <b>annualConsumption</b> blank to use the project's value (or determine-mode if it has none); set it to force rescale mode (sumKwh should equal it)."
    >
      <Controls>
        <Input placeholder="project _id" value={projectId} onChange={(v) => setProjectId(v || '')} />
        <Input placeholder="annualConsumption (optional)" value={annualConsumption} onChange={(v) => setAnnualConsumption(v || '')} />
        <Button onClick={() => run()} disabled={loading}>{loading ? 'Simulating…' : 'Simulate'}</Button>
      </Controls>
      {result && <pre>{result}</pre> || null}
    </DevToolSection>
  );
};
